import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { isNative } from "./platform";

// Feedback aptico (no-op su web). Usare con parsimonia sui tap importanti.
export const tap = async (style = "light") => {
  if (!isNative()) return;
  try {
    const s = style === "heavy" ? ImpactStyle.Heavy : style === "medium" ? ImpactStyle.Medium : ImpactStyle.Light;
    await Haptics.impact({ style: s });
  } catch (e) {}
};

export const notify = async (type = "success") => {
  if (!isNative()) return;
  try {
    const t = type === "error" ? NotificationType.Error : type === "warning" ? NotificationType.Warning : NotificationType.Success;
    await Haptics.notification({ type: t });
  } catch (e) {}
};
